import { useState, useEffect } from 'react';

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    setVisible(window.pageYOffset > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className="
          fixed bottom-6 right-6
          w-12 h-12
          bg-blue-500 text-white
          rounded-full
          shadow-lg
          flex items-center justify-center
          hover:bg-blue-600
          hover:scale-110
          transition-all
          focus:outline-none focus:ring-2 focus:ring-blue-400
          z-50
        "
        aria-label="Scroll to top"
      >
        ↑
      </button>
    )
  );
}

export default ScrollToTopButton;
